import hourglassIcon from "@/assets/hourglass-icon.png";
import chainsIcon from "@/assets/chains-icon.png";
import syringeIcon from "@/assets/syringe-icon.png";

export const Protocols = () => {
  const protocols = [
    {
      title: "Monk Protocols",
      icon: hourglassIcon,
      rituals: ["4AM Exorcism", "The Hourglass Ritual", "Silence Crucifixion"],
      description: "Monks don't negotiate. They wake at 4AM because suffering builds gods. These are the rituals they used to burn weakness out of their souls. No phones. No comfort. No escape from yourself."
    },
    {
      title: "Prison Protocols",
      icon: chainsIcon,
      rituals: ["Cement Cell Test", "The Shame Script", "No Exit Protocol"],
      description: "Convicts don't have options. Four walls. One choice: rot or rise. These protocols were forged in concrete cells by men who had nothing but time and the will to never be weak again."
    },
    {
      title: "Millionaire Dopamine Leash",
      icon: syringeIcon,
      rituals: ["Brain Chemistry Domination", "The Withdrawal", "Neural Reset"],
      description: "Your brain is a chemical weapon,  and it's pointed at you. Millionaires know this. They control dopamine, serotonin, cortisol. You don't. That's why they win and you scroll."
    }
  ];

  return (
    <section className="py-24 bg-void relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-blood/5 via-transparent to-blood/5 animate-smoke" />
      
      <div className="container mx-auto px-4 relative z-10">
        <h2 className="text-5xl md:text-6xl font-black text-center mb-4 tracking-tight">
          <span className="text-blood-bright">The Forbidden Manual</span>
        </h2>
        <p className="text-center text-steel text-xl mb-20">What's Inside</p>
        
        <div className="grid md:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {protocols.map((protocol, index) => (
            <div 
              key={index}
              className="border border-border bg-card/30 backdrop-blur-sm p-8 transition-all hover:border-blood hover:shadow-[0_0_30px_rgba(220,38,38,0.3)] group"
            >
              <div className="flex justify-center mb-6">
                <img 
                  src={protocol.icon} 
                  alt={protocol.title}
                  className="w-24 h-24 opacity-80 group-hover:opacity-100 transition-opacity"
                />
              </div>
              
              <h3 className="text-2xl font-bold text-blood-bright mb-4 text-center uppercase tracking-wide">
                {protocol.title}
              </h3>
              
              <ul className="space-y-2 mb-6">
                {protocol.rituals.map((ritual, idx) => (
                  <li key={idx} className="text-steel font-medium border-l-2 border-smoke pl-3">
                    {ritual}
                  </li>
                ))}
              </ul>
              
              <p className="text-muted-foreground text-sm leading-relaxed">
                {protocol.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
